import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BannerAds = () => {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    axios.get(`${API}/ads`).then((r) => setAds(r.data)).catch(() => {});
  }, []);

  if (!ads.length) return null;

  return (
    <section
      data-testid="banner-ads"
      className="bg-white px-4 md:px-8 lg:px-12 py-16 md:py-24"
    >
      <div className="flex items-center gap-4 mb-8">
        <span className="font-accent uppercase text-[10px] tracking-[0.3em] text-[#4a4a4a]">
          Advertisement
        </span>
        <span className="h-px flex-1 bg-black/10" />
      </div>

      <div className="space-y-6 md:space-y-8">
        {ads.map((ad, i) => (
          <motion.a
            key={ad.id}
            href={ad.url}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            data-testid={`banner-ad-${ad.id}`}
            className="group block overflow-hidden border border-black/10 hover:border-black/40 transition-colors duration-300"
          >
            <img
              src={ad.image}
              alt={ad.name}
              className="w-full h-auto block transition-transform duration-[1.2s] ease-out group-hover:scale-[1.02]"
            />
          </motion.a>
        ))}
      </div>
    </section>
  );
};

export default BannerAds;
